const contactData = {
  sell: 'sell@lollipop.camera',
  collaboration: 'collaboration@lollipop.camera',
  business: 'distribution@lollipop.camera',
  media: 'media.help@lollipop.camera',
};

export default contactData;
